<button [matTooltip]="'FILTERBYRESOURCE' | translate" mat-icon-button [matMenuTriggerFor]="menu"><mat-icon fontSet="mdi" fontIcon="mdi-filter-menu" style="font-size: 1.2em !important;"></mat-icon></button>
<mat-menu #menu="matMenu" xPosition="before" [overlapTrigger]="true">
    <button mat-menu-item *ngFor="let item of listItem" (click)="onMenuItemSelect.next(item.value)">
        <mat-icon [fontIcon]="item.icon" fontSet="mdi"></mat-icon>
        <span>{{ item.name | translate}}</span>
    </button>
</mat-menu>
